$(function () {
    var updating = false;
    $(window).on("scroll", function (e) {
        if (!updating) {
            window.requestAnimationFrame(function () {
                $(".ar-parallax-block").each(function (index, element) {
                    var heights = [];

                    $(".ar-parallax-block__column", element).each(function (childIndex, childElement) {
                        heights[childIndex] = $(childElement).outerHeight();
                    });

                    if (heights[0] === heights[1]) {
                        return;
                    }

                    var shortColumnIndex = 0;
                    var longColumnIndex = 1;

                    if (heights[0] > heights[1]) {
                        shortColumnIndex = 1;
                        longColumnIndex = 0;
                    }

                    var topMargin = 0;
                    if (window.innerWidth >= 1024) {
                        var position = element.getBoundingClientRect();
                        var relativePosition = 0;
                        if (window.innerHeight <= position.height) {
                            relativePosition = Math.max(Math.min(position.top * -1 / (position.height - window.innerHeight), 1), 0);
                        }
                        else {
                            relativePosition = Math.max(Math.min(((window.innerHeight - position.height) - position.top) / (window.innerHeight - position.height), 1), 0);
                        }

                        var sizeDifference = heights[longColumnIndex] - heights[shortColumnIndex];
                        topMargin = sizeDifference * relativePosition;
                    }

                    $(".ar-parallax-block__column:eq(" + shortColumnIndex + ")", element).css("margin-top", topMargin);
                });
                updating = false;
            });
            updating = true;
        }
    });
});
